module.exports = __webpack_public_path__ + "media/images/pekarska-hlavni-6c0d2ab4.jpg";